// Holds socket pushes until startup has loaded the user, then delivers them in
// the order they came. Opened once per page load (StartupEventManager), on
// every page, so pushes off the netplay page are not held forever.
export default function createServerMessageGate(deliver) {
	let open = false;
	const held = [];

	return {
		isOpen: () => open,
		receive(message) {
			if(!message) {
				return;
			}
			if(open) {
				deliver(message);
			}
			else {
				held.push(message);
			}
		},
		open() {
			open = true;
			while(held.length) {
				deliver(held.shift());
			}
		},
	};
}
